import * as S from './animated-item.styled'
import { AnimatedItemProps } from './animated-item.types'

export const DEFAULT_STAGGER_MS = 30
export const DEFAULT_MAX_STAGGER_STEPS = 8

// Note: plays once when the item mounts (fade + slide up), so it is replayed whenever an item
// is added to the DOM again - new list contents, cleared search, a re-shown filter result.
export const AnimatedItem = ({
  animate = true,
  children,
  index = 0,
  staggerMs = DEFAULT_STAGGER_MS,
  maxStaggerSteps = DEFAULT_MAX_STAGGER_STEPS,
  ...props
}: AnimatedItemProps) => (
  <S.Wrapper
    {...props}
    $animate={animate}
    style={{ animationDelay: `${Math.min(index, maxStaggerSteps) * staggerMs}ms` }}
    data-component-id="AnimatedItem"
  >
    {children}
  </S.Wrapper>
)
